export default __webpack_public_path__ + "static/media/koica-logo-blue.ff0e3482.png";